"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _context = require("../context");
var _propTypes = require("../prop-types");
var _utils = require("../utils");
var _excluded = ["theme"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var SpacerPropTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.displayPropTypes), _propTypes.flexPropTypes), _propTypes.flexShrinkPropTypes), _propTypes.widthWithMinMaxPropTypes), _propTypes.heightWithMinMaxPropTypes);
var Spacer = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(SpacerPropTypes)
})(function (_ref) {
  var theme = _ref.theme,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var selectors = theme.selectors;
  return _objectSpread(_objectSpread(_objectSpread({}, (0, _utils.getPropsStyles)(['flex'], props)), (0, _utils.getSpacingStyles)(['width', 'height', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight', 'margin', 'padding'], props, selectors.space)), {}, {
    display: props.display,
    flexShrink: props.flexShrink
  });
});
Spacer.displayName = 'Spacer';
Spacer.defaultProps = {
  flexShrink: 1
};
var SpacerWithDocs = (0, _stencilReactDesc.describe)(Spacer).description('Adds blank space between other elements on the page.');
SpacerWithDocs.propTypes = SpacerPropTypes;
var _default = SpacerWithDocs;
exports.default = _default;